import { render } from "./ListIzinPendingView.vue?vue&type=template&id=599a7acf"
import script from "./ListIzinPendingView.vue?vue&type=script&lang=js"
export * from "./ListIzinPendingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__